import { DangerConfirmDialog } from "@/routes/admin/DangerConfirmDialog";

// Story 11.8 AC8 — the Change Password confirmation (Screen 21).
//
// NOT GATED ON ORIGIN. A `webapp_legacy` + inactive target is a VALID target: 11.4
// makes this endpoint the credentials-resend path for legacy B2C accounts
// (seam-114), so disabling the button for one would invent a refusal the server
// does not make. The only refusal in this family — `learnworlds_new` + non-active —
// arrives from the server as `409 ADMIN-012` and is surfaced from the response.

export interface ChangePasswordDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The affected user, named in the copy (UX spec `:832`). */
  userName: string;
  /** Where the temporary password will be sent. */
  email: string;
  isPending: boolean;
  onConfirm: () => void;
}

export function ChangePasswordDialog({
  open,
  onOpenChange,
  userName,
  email,
  isPending,
  onConfirm,
}: ChangePasswordDialogProps) {
  return (
    <DangerConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Send password reset"
      description={`This invalidates ${userName}'s current password and emails a temporary one to ${email}. They'll be asked to set a new password when they sign in.`}
      // Not destructive: the account survives, only the credential is replaced. The
      // primary variant keeps `destructive` meaning "this removes access".
      confirmVariant="primary"
      confirmLabel="Send reset email"
      pendingLabel="Sending…"
      isPending={isPending}
      onConfirm={onConfirm}
    />
  );
}
